import React, { useState, useEffect } from 'react';
import { Button, LoadingIcon } from '@prosolve/common-components-ui'
import styled from 'styled-components';
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useDataSessionBlueprints from '../../dataHooks/useDataSessionBlueprints';
// import Cookies from 'js-cookie';

const Table = styled.table`
  background: #ffffff;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  color: #080808;
  font-size: 14px;
  border-spacing: 0;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  cursor: pointer;
  &:last-child td {
    border-bottom: none;
  }
`;

const TableColumn = styled.td`
  padding: 8px 20px;
  border-bottom: 1px solid #c4c4c4;
`;

export default () => {
  const navigate = useNavigate();

  const {
    fetchEventBlueprints
  } = useDataSessionBlueprints();

  // const adminPermissionsCookies = Cookies.get('adminPermissions') || '';
  const isReadOnly = false; // !(adminPermissionsCookies.indexOf('ASSESSMENT_BUILDER_EDIT') > -1);

  const [isLoading, setIsLoading] = useState(true)
  const [sessionBlueprints, setSessionBlueprints] = useState([]);

  const getEventBlueprints = async () => {
    setIsLoading(true);
    try {
      const sBlueprints = await fetchEventBlueprints();
      setSessionBlueprints(sBlueprints)
    } catch (e) {
      setSessionBlueprints([])
    }
    setIsLoading(false);
  }

  useEffect(() => {
    getEventBlueprints()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const addEditSessionBlueprint = async (id) => {
    navigate(`eventTemplate?id=${id}`);
  }

  return (
    isLoading ?
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <LoadingIcon />
    </div>
    :

    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '20px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px', paddingBottom: '20px' }}>
        <Button
          style={{ width: '250px' }}
          $colored={true}
          $disabled={isReadOnly}
          onClick={() => {
            if (!isReadOnly) {
              addEditSessionBlueprint('new')
            }
          }}
        >
          {'Create New Event Template'}
        </Button>
      </div>
      { 
        sessionBlueprints.length > 0 ?
        <Table>
          <TableBody>
            {
              sessionBlueprints
              .sort((a, b) => a.Name.localeCompare(b.Name))
              .map(({ Id, Name = '' }) => {
                return (
                  <TableRow key={Id} onClick={() => addEditSessionBlueprint(Id)}>
                    <TableColumn>
                      {Name}
                    </TableColumn>
                    <TableColumn style={{ textAlign: 'right', color: '#0280c6' }}>
                      <FaArrowRight style={{ fontSize: '22px' }}  />
                    </TableColumn>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
        :
        <div style={{ color: '#565656', fontStyle: 'italic', fontSize: '14px' }}>
          {'Currently no session blueprints found. Click the above button to create your first.'}
        </div>
      }
    </div>
  )
}